import { Helmet } from 'react-helmet-async';
import React from 'react';
import { Button, Col, Grid, Row } from 'react-bootstrap';
import { ErrorNotFoundIcon } from '../components/icons/ErrorNotFoundIcon.jsx';
import { Link } from '../components/Link.jsx';

const NotFoundPage = () => {
  return (
    <div className="component-bg-white">
      <Helmet>
        <title>Page not Found | ChangeSync</title>
      </Helmet>
      <Row>
        <Grid>
          <Col sm={12}>
            <div
              className="component-xl component-bg-white component-xl-padding-vertical component-no-horizontal-padding"
              style={{
                height: 'calc(100vh - 90px)',
              }}
            >
              <div className="center-block">
                <Row
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '24px',
                  }}
                >
                  <div
                    style={{
                      maxWidth: '780px',
                      width: '100%',
                      marginBottom: '40px',
                    }}
                  >
                    <ErrorNotFoundIcon />
                  </div>
                  <h2 className="h2 m-b-16 text-center">
                    The URL may be misspelled or the page you're looking for is
                    no longer available.
                  </h2>
                  <Link route="/">
                    <Button
                      block
                      bsStyle="primary"
                      style={{ maxWidth: '200px' }}
                    >
                      Open Home Page
                    </Button>
                  </Link>
                </Row>
              </div>
            </div>
          </Col>
        </Grid>
      </Row>
    </div>
  );
};

export default NotFoundPage;